import { render, staticRenderFns } from "./ecoShopList.vue?vue&type=template&id=2bccb05c"
import script from "./ecoShopList.vue?vue&type=script&lang=js"
export * from "./ecoShopList.vue?vue&type=script&lang=js"
import style0 from "./ecoShopList.vue?vue&type=style&index=0&id=2bccb05c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports